import { selfAxios } from "@oppein/op-utils";
/**
 * 按客户查订单
 * @param params
 * @returns
 */
export async function getUserScope(params = {}) {
  params = {
    ajaxTime: Date.now(),
    ...params,
  };
  const { data } = await selfAxios.get("/crm/user/getUserScope", {
    params,
  });
  return data;
}

/**
 * 分页查询客户以及订单信息
 * @param params
 * @returns
 */
export async function queryCustomerOrderPage(params = {}) {
  const { data } = await selfAxios.post(
    "/designordercenter/customerOrder/queryCustomerOrderPage",
    params,
  );
  return data;
}

/**
 * 订单标签查询
 * @param params {Object} {orderIdList: string[]}
 * @returns
 */
export async function queryOrderBusinessOperationsApplyList(params = {}) {
  const { data } = await selfAxios.post(
    "/mtdsretail/specialApply/queryOrderBusinessOperationsApplyList",
    params,
  );
  return data;
}

/**
 * 客户服务号详细信息
 * @param serviceId
 * @returns
 */
export async function queryByServiceId(serviceId) {
  const { data } = await selfAxios.get(
    "/designordercenter/customer/queryByServiceId", ///crmapi/internal/customer/queryByServiceId
    {
      params: {
        serviceId,
      },
    },
  );
  return data;
}

/**
 * 查询 客户订单明细 （单个客户）
 * @returns
 */
export async function customerOrderPlaceGetPageListByQry(params = {}) {
  const { data } = await selfAxios.post(
    "/designordercenter/customerOrderPlace/getPageListByQry",
    params,
  );
  return data;
}

/**
 * 编辑-客户订单（建单接口）
 * @returns
 */
export async function customerOrderPlaceSaveLocal(params = {}) {
  const { data } = await selfAxios.post(
    "/designordercenter/customerOrderPlace/saveLocal",
    params,
  );
  return data;
}

/**
 * 根据条件查询配置
 * @returns
 */
export async function productionOrderMarketConfigListByCondition(params = {}) {
  const { data } = await selfAxios.post(
    "/designordercenter/productionOrderMarketConfig/listByCondition",
    params,
  );
  return data;
}

/**
 * 根据条件查询招商渠道配置
 * @returns
 */
export async function productionOrderMarketConfigQueryOrgChannels(params = {}) {
  const { data } = await selfAxios.post(
    "/designordercenter/productionOrderMarketConfig/queryOrgChannels",
    params,
  );
  return data;
}

/**
 * 保存配置组织配置
 * @returns
 */
export async function productionOrderMarketConfigSaveOrgConfig(params = {}) {
  const { data } = await selfAxios.post(
    "/designordercenter/productionOrderMarketConfig/saveOrgConfig",
    params,
  );
  return data;
}

/**
 * 获取虚拟店铺列表
 * @returns
 */
export async function getFictitiousShopOptions(params = {}) {
  const { data } = await selfAxios.get(
    "/ucenterapi/internal/shop/getFictitiousShopListByOrgId",
    { params },
  );
  return data;
}

/**
 * 查询客户列表
 * @returns
 */
export async function queryInsideCustomerPage(params = {}) {
  const { data } = await selfAxios.post(
    "/designapi/design/insideProcessOrder/queryInsideCustomerPage",
    params,
  );
  return data;
}

/**
 * 根据 实体门店Id 获取实体门店信息
 * @returns
 */
export async function getShopById(params = {}) {
  const { data } = await selfAxios.get(
    "/ucenterapi/internal/shop/getShopById",
    { params },
  );
  return data;
}



// WEBPACK FOOTER //
// ./src/api/checkOrderByCustomer/index.js